import * as React from 'react';

import { AngularDirective } from '../../../common/react/components/AngularDirective';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';

export const Template = `<div ng-controller="RequestPasswordResetCtrl" ng-include="'requestPasswordReset.html'"></div>`;

export interface RequestPasswordResetProviderProps extends ReactDirectiveProps {}

export const RequestPasswordResetProvider = (props: RequestPasswordResetProviderProps): JSX.Element => {
  return(
    <div>
      <AngularDirective
        angularContext={props.angularContext}
        template={Template}
      />
    </div>
  );
};
